import { render, staticRenderFns } from "./AccountCreation.vue?vue&type=template&id=70326de8&scoped=true&"
import script from "./AccountCreation.vue?vue&type=script&lang=js&"
export * from "./AccountCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70326de8",
  null
  
)

export default component.exports